import { Grid, Stack } from '@mui/material'
import { GItem, GItemContainer, MiddleGItem } from '../components/common/grids'
import { SubTitle } from '../components/common/subTitle'
import { AttentionLabel } from '../components/common/attentionLabel'
import { ErrorMessageCard } from '../components/common/errorMessageCard'
import { BottomButtonGroup } from '../components/common/bottomButtonGroup'
import { ButtonOutlinedWarningL } from '../components/common/buttons/buttonOutlinedWarningL'
import { BackButton } from '../components/common/buttons/backButton'
import { Form } from '../components/common/inputs/form'
import { TelTextBox } from '../components/common/inputs/telTextBox'
import { TextBox } from '../components/common/inputs/textBox'
import { translate } from '../../i18n'
import { yesNo } from '../../containers/common/constant/classification'
import { GetCategoryMstDto } from '../../dataAccess/webApi/dto/categoryMstDto'
import { useAction } from '../../containers/memberModifyChildFamilyHospital/memberModifyChildFamilyHospitalService'

export const MemberModifyChildFamilyHospital = () => {
  const {
    CATEGORY_KEYS,
    formMethods,
    categoryMst,
    onSubmit,
    childrenResultCode
  } = useAction()

  const categories =
    categoryMst?.filter((mst) => CATEGORY_KEYS.includes(mst.category))
      .sort((a, b) => CATEGORY_KEYS.indexOf(a.category) - CATEGORY_KEYS.indexOf(b.category));

  return (
    <Form formMethods={formMethods} onSubmit={onSubmit}>
      <Stack spacing={2}>
        <Grid container>
          <Grid item md={3}></Grid>
          <Grid item xs={12} md={6}>
            <Stack spacing={2}>
              {!!categories?.length ?
                (<>
                  <SubTitle title={"かかりつけ医"} />
                  {categories &&
                    categories.map((obj) => {
                      return (
                        <InputForm categoryMst={obj} key={obj.category} />
                      )
                    })
                  }
                </>)
                :
                (<>
                  {translate('memberModifyChildFamilyHospital.error.noCategoryMst')}
                </>)
              }
            </Stack>
          </Grid>
        </Grid>
        {
          !!childrenResultCode && (
            <ErrorMessageCard
              messages={[translate(`memberModifyChildFamilyHospital.error.childrenResultCode${childrenResultCode}`)]}
            />
          )

        }
        <BottomButtonGroup>
          <ButtonOutlinedWarningL fullWidth type="submit">
            {translate('memberModifyChildFamilyHospital.button.decision')}
          </ButtonOutlinedWarningL>
          <BackButton />
        </BottomButtonGroup>
      </Stack>
    </Form>
  )
}

interface InputFormProps {
  categoryMst: GetCategoryMstDto,
  facilitiesTypeList?: { value: string, label: string }[]
}

/** 各項目の入力フォーム */
const InputForm = (props: InputFormProps) => {
  const { categoryMst } = props

  const render = () => {
    switch (categoryMst.category) {
      case "familyHospitalTel1":
      case "familyHospitalTel2":
      case "familyHospitalTel3":
        return (
          <GItemContainer xs={12} rowSpacing={1}>
            <MiddleGItem xs={5} sm={2}>
              {categoryMst.required === yesNo.yes && <AttentionLabel>*</AttentionLabel>}
              {categoryMst.altCategoryName ?? categoryMst.name}
            </MiddleGItem>
            <GItem xs={7} sm={10}>
              <TelTextBox
                label={categoryMst.altCategoryName ?? categoryMst.name}
                name={categoryMst.category}
                required={categoryMst.required === yesNo.yes}
              />
            </GItem>
          </GItemContainer>
        )
      default:
        return (
          <GItemContainer xs={12} rowSpacing={1}>
            <MiddleGItem xs={5} sm={2}>
              {categoryMst.required === yesNo.yes && <AttentionLabel>*</AttentionLabel>}
              {categoryMst.altCategoryName ?? categoryMst.name}
            </MiddleGItem>
            <GItem xs={7} sm={10}>
              <TextBox
                label={categoryMst.altCategoryName ?? categoryMst.name}
                name={categoryMst.category}
                maxLength={categoryMst.maxLength ?? 100}
                rows={4}
                required={categoryMst.required === yesNo.yes}
                fullWidth
              />
            </GItem>
          </GItemContainer>)
    }
  }
  return (render())
}
